
//#region src/types/model/link.ts
/**
* Type of a link custom type field.
*
* More details: {@link https://prismic.io/docs/link}
*/
const CustomTypeModelLinkSelectType = {
	Document: "document",
	Media: "media",
	Web: "web"
};

//#endregion
exports.CustomTypeModelLinkSelectType = CustomTypeModelLinkSelectType;
//# sourceMappingURL=link.cjs.map